import Vue from "vue";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, min, ext, email } from "vee-validate/dist/rules";

extend("ext", ext);
extend("required", required);
extend("email", email);
extend("min", min);
extend("password", {
  params: ["target"],
  validate(val, { target }) {
    return val === target;
  },
  message: "Passwords don't match"
});
extend("noSpecialChars", {
  message:
    "Radius username must only be alphanumeric and may contain '@', '_' and '.' characters. No spaces allowed.",
  validate: val =>
    !/^\s/.test(val) &&
    (
      /^[a-zA-Z0-9@_.\-]*$/.test(val) ||
      /^[^@][a-zA-Z0-9@_.]*$/.test(val)
    )
});

extend("radiusUsername", {
  message: "Radius username format invalid",
  validate: val =>
    /^[^@]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}$/.test(val) ||
    /^[^@]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}$/.test(val) ||
    /^[^@]+@[a-zA-Z0-9]+@[a-zA-Z0-9]+$/.test(val) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}$/.test(val) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}$/.test(
      val
    ) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+$/.test(val) ||
    /^[^@]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}(?:\.[a-zA-Z0-9]{2,})+$/i.test(val) ||
    /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9]+\.[a-zA-Z0-9]{2,}(?:\.[a-zA-Z0-9]{2,})+$/i.test(
      val
    )
});

extend("noWhitespace", {
  message: "Password must not contain spaces or whitespace characters",
  validate: val => /^\S+$/.test(val)
});

extend("allowHash", {
  message:
    "Service ID must only be alphanumeric and may contain '#' character.",
  validate: val => !/[!$%^&*()+\-=[\]{};':"\\|,<>/?]/.test(val)
});

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
